import React from "react";
import { Modal } from "react-bootstrap";
import { ApplicationState } from "../../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import {
  acceptConfirmDiagnosisModal,
  hideConfirmDiagnosisModal,
} from "../../../../../../store/groups/actions";
import { StudentEntry } from "../../../../../../store/onboarding/types";

type PropsFromState = {
  showModal: boolean;
  selectedStudentEntry?: StudentEntry;
};

type DispatchProps = {
  hideConfirmDiagnosisModal: () => any;
  acceptConfirmDiagnosisModal: () => any;
};

type Props = PropsFromState & DispatchProps;

class ConfirmDiagnosisModal extends React.Component<Props> {
  render() {
    const { showModal } = this.props;
    return (
      <Modal
        show={showModal}
        onHide={this.props.hideConfirmDiagnosisModal}
        animation={false}
        backdropClassName="customDarkModalBackdrop in"
        centered
      >
        <Modal.Header
          closeButton
          className={`purpleModalHeader font-weight-bold`}
        >
          <Modal.Title>Add Diagnostic Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center mb-3">
            <p className="font-weight-bold">Are you sure you want to add diagnostic data?</p>
            <p>
              This student has not been identified as needing intervention.
            </p>
          </div>
          <hr />
          <div className="d-flex justify-content-between">
            <button
              className="whiteBtnSm"
              onClick={this.props.hideConfirmDiagnosisModal}
            >
              Cancel
            </button>
            <button
              className="blueBtnSm ml-2"
              onClick={this.props.acceptConfirmDiagnosisModal}
            >
              Add Data
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = ({ groups }: ApplicationState): PropsFromState => {
  return {
    showModal: groups.modalsState.confirmDiagnosisModal,
    selectedStudentEntry: groups.selectedStudentEntry,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      hideConfirmDiagnosisModal: hideConfirmDiagnosisModal,
      acceptConfirmDiagnosisModal: acceptConfirmDiagnosisModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDiagnosisModal);
